import { Component } from '@angular/core';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';

export interface IConfirmDialogModel {
    title: string;
    subTitle: string;
    message: string;

}

@Component({
    selector: 'confirm-dialog',
    styleUrls: ['./confirm-dilaog.component.css'],
    templateUrl: './confirm-dialog.component.html'
})
export class ConfirmDialogComponent implements IConfirmDialogModel {

    title: string;
    subTitle: string;
    message: string;

    result: any;

    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig
    ) {
    }

    ngOnInit() {
        this.message = this.config.data.message;
        this.title = this.config.data.title;
        this.subTitle = this.config.data.subTitle;
    }

    close() {
        this.ref.close();
    }

    confirm() {
        // we set dialog result as true on click on confirm button,
        // then we can get dialog result from caller code
        this.result = true;
        this.close();
    }


}
